<script lang="ts">
  import Button from '$components/Button.svelte';
  import type { GQLError } from '$types/races';

  export let stackTrace: string | GQLError[] = '';

  $: stackTraceMessage = '';
  $: {
    if (stackTrace instanceof Array) {
      stackTraceMessage = stackTrace.map((error) => error.message).join('\n');
    } else {
      stackTraceMessage = stackTrace;
    }
  }

  $: console.log(stackTraceMessage);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="1"
  stroke="currentColor"
  class="h-10 w-10 text-gray-600"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M15.182 16.318A4.486 4.486 0 0012.016 15a4.486 4.486 0 00-3.198 1.318M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"
  />
</svg>
<span class="mt-2 font-semibold">Sorry, we encountered an error</span>
<span class="mb-2 mt-4 text-gray-600">Try refreshing the page</span>
<Button
  size="large"
  on:click={() => {
    location.reload();
  }}
>
  Refresh
</Button>
{#if stackTraceMessage}
  <span
    class="mt-10 rounded-lg border-2 border-gray-200 bg-gray-100 p-2 font-mono text-[9px] text-gray-600"
    >{stackTraceMessage}</span
  >
{/if}
